module.exports = __webpack_public_path__ + "static/media/How to give or add permissions to team members.62c714ec.png";